import { render, staticRenderFns } from "./DashboardViewSetting.vue?vue&type=template&id=36b07ace&"
import script from "./DashboardViewSetting.vue?vue&type=script&lang=js&"
export * from "./DashboardViewSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports